// extracted by mini-css-extract-plugin
export default {"pie_chart_section_wrapper":"PieChartComponent_pie_chart_section_wrapper__mZO+x"};